<div class="table-container">
  <table class="table table-bordered">
    <thead>
      <tr>
        <th></th>
        <th *ngFor="let header of parentHeaders">
          {{ header.label }}
        </th>
      </tr>

    </thead>
    <tbody>

      <ng-container *ngFor="let row of tableData">
        <tr>
          <!-- Expand/Collapse Button -->
          <td (click)="row[expandKey] = !row[expandKey]" style="width: 20px; cursor: pointer;">
            <mat-icon *ngIf="!row[expandKey]">expand_more</mat-icon>
            <mat-icon *ngIf="row[expandKey]">expand_less</mat-icon>
          </td>
          <!-- Parent Row Data -->

          <td *ngFor="let header of parentHeaders">
            <span *ngIf="header.key === 'assetName'; else defaultContent" (click)="emitAssetName(row)"
              [ngClass]="selectedTabName !=='Asset'?'blue':''">
              {{ row[header.key] }}
            </span>
            <ng-template #defaultContent>
              {{ row[header.key] }}
            </ng-template>
          </td>
        </tr>

        <!-- Expanded Row -->
        <tr *ngIf="shouldExpand(row)">
          <td [attr.colspan]="getColspan()">

            <table class="table table-sm inside-table">
              <thead>
                <tr>
                  <th *ngFor="let header of nestedHeaders" style="font-size: 14px;">
                    {{ header.label }}
                  </th>


                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let nested of row[nestedKey]">
                  <td *ngFor="let header of nestedHeaders" style="font-size: 14px;">
               
                    
                    
                  <!-- [ngClass]="selectedTabName=='Asset'?'blue':''" -->
                <span *ngIf="header.key == 'employeeName'; else defaultContent"
                      (click)="emitAssetNameinside(nested)" style="color: blue;">
                      {{ nested[header.key] }}
                    </span>
                    <ng-template #defaultContent>
                      {{ nested[header.key] }}
                    </ng-template>
                    <textarea *ngIf="header.key=='currentAssetDescription'" rows="2" cols="4" class="edittextarea"
                      maxlength="255" placeholder="description...." readonly>
                  </textarea>
                    <textarea *ngIf="header.key=='employeeComment'" rows="2" cols="4" class="edittextarea"
                      maxlength="255" placeholder="comment...." readonly>
                    </textarea>
                    <span *ngIf="header.key === 'assetRepairTime' && nested.assetRepairTime != null">days</span>

                    <mat-icon *ngIf="header.key == ''" class="red-cl" (click)="deleteData(nested.id)">delete</mat-icon>

                  </td>
                  <!-- Action column -->

                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>